export enum EEnvironment {
    TEST = 'test',
    DEV = 'development',
    PRODUCTION = 'production',
}
